import React from "react";
import {
  Box,
  Container,
  Stack,
  SimpleGrid,
  Text,
  Link,
  useColorModeValue,
  Heading,
  VStack,
  Icon,
  Flex,
  Divider,
  Wrap,
  WrapItem,
  Image,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import {
  FaFacebook,
  FaInstagram,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaExternalLinkAlt,
} from "react-icons/fa";
import NTPLogo from "ntp-logo-react";

const ListHeader = ({ children }) => {
  return (
    <Text
      fontWeight="500"
      fontSize="lg"
      mb={2}
      color={useColorModeValue("gray.700", "gray.200")}
    >
      {children}
    </Text>
  );
};

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Divider />
      <Box
        bg={useColorModeValue("gray.50", "gray.900")}
        color={useColorModeValue("gray.700", "gray.200")}
      >
        <Container as={Stack} maxW={"7xl"} py={10}>
          <SimpleGrid
            templateColumns={{ sm: "1fr 1fr", md: "2fr 1fr 1fr 1fr" }}
            spacing={8}
          >
            {/* Company Info */}
            <Stack spacing={6}>
              <Heading
                fontSize={"2xl"}
                bgGradient="linear(to-r, black, red.500)"
                bgClip="text"
              >
                TRAVEL TIME
              </Heading>
              <Text fontSize={"md"} maxW={"400px"}>
                Travel Time - a trusted company in Corporate and B2B Travel
                Solutions - has built its reputation by consistently delivering
                excellence. Guided by a customer-centric philosophy and powered
                by innovative technology, Travel Time is shaping the future of
                Corporate Travel Management.
              </Text>
              <HStack spacing={4}>
                <IconButton
                  aria-label="Facebook"
                  icon={<FaFacebook />}
                  size="lg"
                  color={"white"}
                  bg={"facebook.400"}
                  _hover={{ bg: "facebook.500" }}
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/traveltimeromania",
                      "_blank",
                    )
                  }
                />
                <IconButton
                  aria-label="Instagram"
                  icon={<FaInstagram />}
                  size="lg"
                  color={"white"}
                  bg={"pink.400"}
                  _hover={{ bg: "pink.500" }}
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/traveltime.ro/",
                      "_blank",
                    )
                  }
                />
              </HStack>
            </Stack>

            {/* Contact Info */}
            <Stack align={"flex-start"}>
              <ListHeader>Contact</ListHeader>
              <HStack>
                <Icon as={FaMapMarkerAlt} color="teal.400" />
                <Text fontSize="md">
                  Popa Tatu Street, No. 49, Sector 1, Bucharest
                </Text>
              </HStack>
              <HStack>
                <Icon as={FaEnvelope} color="teal.400" />
                <Link href="mailto:parteneri@travel-time.ro" fontSize="md">
                  parteneri@travel-time.ro
                </Link>
              </HStack>
              <HStack>
                <Icon as={FaPhone} color="teal.400" />
                <Link href="tel:+40 371121272" fontSize="md">
                  +40371121272
                </Link>
              </HStack>
            </Stack>

            {/* Useful Links */}
            <Stack align={"flex-start"}>
              <ListHeader>Useful Links</ListHeader>
              <Link href="/agentii-partenere" onClick={scrollToTop}>
                Partner Agencies
              </Link>
              <Link href="/servicii" onClick={scrollToTop}>
                Services
              </Link>
              <Link href="/consultanta" onClick={scrollToTop}>
                Consultancy
              </Link>
              <Link href="/contact" onClick={scrollToTop}>
                Contact
              </Link>
              {/* <Link href="/termenisiconditii" onClick={scrollToTop}>
                Termeni si Conditii
              </Link> */}
            </Stack>

            {/* Company Details */}
            <Stack align={"flex-start"}>
              <ListHeader>Identification Data</ListHeader>
              <Text fontSize="sm">SC TRAVEL TIME D&R SRL</Text>
              <Text fontSize="sm">CIF: RO17926970</Text>
              <Text fontSize="sm">Nr. Reg. Com.: J40/15226/2005</Text>

              {/* Logos Section */}
              <VStack spacing={4} align="start" mt={4}>
                {/* First row of logos */}
                <HStack spacing={4}>
                  <Image src="../images/iata.png" alt="IATA" h="35px" />
                  <Image src="../images/anat.png" alt="ANAT" h="35px" />
                  <Image
                    src="../images/logo-travelnation.png"
                    alt="tRAVEL NATION"
                    h="35px"
                  />
                </HStack>

                {/* NTP Logo */}
                <Box w="full">
                  <NTPLogo
                    color="#74deec"
                    version="orizontal"
                    secret="136590"
                  />
                </Box>

                {/* SOL and SAL logos */}
                <Flex justify="center" gap={4} w="full" flexWrap="wrap">
                  <Link
                    href="https://consumer-redress.ec.europa.eu/index_en"
                    isExternal
                    _hover={{ opacity: 0.8 }}
                  >
                    <Image
                      src="../images/SOL.png"
                      alt="SOL Logo"
                      w="140px"
                      h="35px"
                    />
                  </Link>
                  <Link
                    href="https://reclamatiisal.anpc.ro/"
                    isExternal
                    _hover={{ opacity: 0.8 }}
                  >
                    <Image
                      src="../images/SAL.png"
                      alt="SAL Logo"
                      w="140px"
                      h="40px"
                    />
                  </Link>
                </Flex>
              </VStack>
            </Stack>
          </SimpleGrid>
        </Container>

        <Divider />

        <Box py={6} bg={useColorModeValue("gray.100", "gray.800")}>
          <Container maxW={"7xl"}>
            <VStack spacing={4}>
              {/* Documents Links */}
              <Wrap justify="center" spacing={3} px={4}>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat%20lansare%20proiect%20ECOSTART%20312794.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Lansare proiect - 312794 - Ecostart
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat%20lansare%20proiect%20ID%20312355%20-%20CREATE.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Lansare proiect - 312355 - Create
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat de Presa_inchidere Proiect 131118 - Practic-On.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Finalizare proiect - 131118 -
                    Practic-On
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat de Presa_MFE 131117_inchidere proiect - Spots.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Finalizare proiect - 131117 - Spots
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat-lansare-proiect - 133306 - Young Pro.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Lansare proiect - 133306 - Young Pro
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Comunicat-inchidere-proiect - 133306 - Young Pro.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Comunicat de presa - Finalizare proiect - 133306 - Young Pro
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>
                  <Link
                    href="/create"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    C.R.E.A.T.E
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
              </Wrap>
            </VStack>
          </Container>
        </Box>

        <Divider />

        {/* Bottom Bar */}
        <Box py={6} bg={useColorModeValue("gray.100", "gray.800")}>
          <Container maxW={"7xl"}>
            <VStack spacing={4}>
              {/* Documents Links */}
              <Wrap justify="center" spacing={3} px={4}>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Licenta%20turism%20TRAVEL%20TIME%20D&R%20-%202026.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Tourism License: 236/ 28.04.2026
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/iata%20certficat%202025.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    IATA Certification
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/CUI%20TRAVEL%20TIME.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Business Registration Certificate
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/BREVET%20Turism.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Tourism Certification
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Polita%20insolvabilitate%20TRAVEL%20TIME%20D&R.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Insurance Policy
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/certificat%20ISO%209001.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    ISO Certificate
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
              </Wrap>

              {/* Second Row of Links */}
              <Wrap justify="center" spacing={3} px={4}>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Draft%20Contract%20Turist.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Tourist Contract
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://anpc.ro/"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    ANPC
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://legislatie.just.ro/Public/DetaliiDocument/257649"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Mandatory ANPC Measures
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Termeni%20si%20conditii%20TT.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Terms and Conditions
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Politica GDPR TT.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    GDPR
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
                <WrapItem>•</WrapItem>
                <WrapItem>
                  <Link
                    href="https://www.travel-time.ro/images/documente/Politica Cookies TT.pdf"
                    isExternal
                    color={useColorModeValue("blue.600", "blue.200")}
                    fontSize="sm"
                    display="flex"
                    alignItems="center"
                    _hover={{ textDecoration: "none", color: "blue.400" }}
                  >
                    Cookies Policy
                    <Icon as={FaExternalLinkAlt} ml={1} boxSize={3} />
                  </Link>
                </WrapItem>
              </Wrap>

              {/* Copyright */}
              <Text
                pt={4}
                fontSize="sm"
                textAlign="center"
                color={useColorModeValue("gray.600", "gray.400")}
              >
                © {new Date().getFullYear()} Travel Time D&R. All rights
                reserved.
              </Text>
            </VStack>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Footer;

// import React, { useState } from "react";
// import {
//   Box,
//   Container,
//   Stack,
//   SimpleGrid,
//   Text,
//   Link,
//   useColorModeValue,
//   Heading,
//   VStack,
//   HStack,
//   IconButton,
//   Button,
//   Collapse,
//   Center,
//   Flex,
//   Divider,
//   Badge,
//   Wrap,
//   WrapItem,
//   Image,
// } from "@chakra-ui/react";
// import {
//   FaFacebook,
//   FaInstagram,
//   FaEnvelope,
//   FaPhone,
//   FaMapMarkerAlt,
//   FaExternalLinkAlt,
//   FaChevronDown,
//   FaChevronUp,
//   FaFileAlt,
//   FaCertificate,
//   FaShieldAlt,
//   FaGavel,
// } from "react-icons/fa";

// const ModernFooter = () => {
//   const [showDocuments, setShowDocuments] = useState(false);
//   const [showCertifications, setShowCertifications] = useState(false);

//   const bgColor = useColorModeValue("gray.50", "gray.900");
//   const cardBg = useColorModeValue("white", "gray.800");
//   const borderColor = useColorModeValue("gray.200", "gray.700");

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   const navigationLinks = [
//     { label: "Services", href: "/services" },
//     { label: "Partner Agencies", href: "/agentii-partenere" },
//     { label: "Consultancy", href: "/consultancy" },
//     { label: "Contact", href: "/contact" },
//   ];

//   const certificationDocs = [
//     {
//       label: "Tourism License: 236/04.12.2018",
//       href: "https://www.travel-time.ro/images/documente/Licenta%20turism%20TRAVEL%20TIME%20D&R%20.pdf",
//       icon: FaCertificate,
//       color: "blue",
//     },
//     {
//       label: "IATA Certification",
//       href: "https://www.travel-time.ro/images/documente/iata%20certficat%202025.pdf",
//       icon: FaCertificate,
//       color: "green",
//     },
//     {
//       label: "ISO 9001 Certificate",
//       href: "https://www.travel-time.ro/images/documente/certificat%20ISO%209001.pdf",
//       icon: FaShieldAlt,
//       color: "purple",
//     },
//     {
//       label: "Business Registration",
//       href: "https://www.travel-time.ro/images/documente/CUI%20TRAVEL%20TIME.pdf",
//       icon: FaFileAlt,
//       color: "orange",
//     },
//     {
//       label: "Tourism Certification",
//       href: "https://www.travel-time.ro/images/documente/BREVET%20Turism.pdf",
//       icon: FaCertificate,
//       color: "teal",
//     },
//     {
//       label: "Insurance Policy",
//       href: "https://www.travel-time.ro/images/documente/Polita%20insolvabilitate%20TRAVEL%20TIME%20D&R.pdf",
//       icon: FaShieldAlt,
//       color: "red",
//     },
//   ];

//   const legalDocs = [
//     {
//       label: "Terms and Conditions",
//       href: "https://www.travel-time.ro/images/documente/Termeni%20si%20conditii%20TT.pdf",
//       icon: FaGavel,
//     },
//     {
//       label: "GDPR Policy",
//       href: "https://www.travel-time.ro/images/documente/Politica GDPR TT.pdf",
//       icon: FaShieldAlt,
//     },
//     {
//       label: "Cookies Policy",
//       href: "https://www.travel-time.ro/images/documente/Politica Cookies TT.pdf",
//       icon: FaFileAlt,
//     },
//     {
//       label: "Tourist Contract",
//       href: "https://www.travel-time.ro/images/documente/Draft%20Contract%20Turist.pdf",
//       icon: FaFileAlt,
//     },
//   ];

//   const projectDocs = [
//     {
//       label: "ECOSTART Project Launch",
//       href: "https://www.travel-time.ro/images/documente/Comunicat%20lansare%20proiect%20ECOSTART%20312794.pdf",
//     },
//     {
//       label: "CREATE Project Launch",
//       href: "https://www.travel-time.ro/images/documente/Comunicat%20lansare%20proiect%20ID%20312355%20-%20CREATE.pdf",
//     },
//     {
//       label: "Young Pro Project",
//       href: "https://www.travel-time.ro/images/documente/Comunicat-lansare-proiect - 133306 - Young Pro.pdf",
//     },
//     {
//       label: "C.R.E.A.T.E Program",
//       href: "/create",
//     },
//   ];

//   return (
//     <Box bg={bgColor} color={useColorModeValue("gray.700", "gray.200")}>
//       {/* Main Footer Content */}
//       <Container maxW="7xl" py={16}>
//         <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={8}>
//           {/* Company Info */}
//           <VStack align="start" spacing={6}>
//             <VStack align="start" spacing={4}>
//               <Heading
//                 fontSize="3xl"
//                 bgGradient="linear(to-r, blue.600, red.500)"
//                 bgClip="text"
//                 fontFamily="Montserrat"
//                 fontWeight="700"
//               >
//                 TRAVEL TIME
//               </Heading>
//               <Text fontSize="sm" color="gray.600" lineHeight="tall">
//                 A trusted company in Corporate and B2B Travel Solutions,
//                 consistently delivering excellence through customer-centric
//                 philosophy and innovative technology.
//               </Text>
//             </VStack>

//             <HStack spacing={3}>
//               <IconButton
//                 aria-label="Facebook"
//                 icon={<FaFacebook />}
//                 size="md"
//                 colorScheme="facebook"
//                 variant="solid"
//                 onClick={() =>
//                   window.open(
//                     "https://www.facebook.com/traveltimeromania",
//                     "_blank"
//                   )
//                 }
//                 _hover={{ transform: "translateY(-2px)" }}
//                 transition="all 0.2s"
//               />
//               <IconButton
//                 aria-label="Instagram"
//                 icon={<FaInstagram />}
//                 size="md"
//                 colorScheme="pink"
//                 variant="solid"
//                 onClick={() =>
//                   window.open(
//                     "https://www.instagram.com/traveltime.ro/",
//                     "_blank"
//                   )
//                 }
//                 _hover={{ transform: "translateY(-2px)" }}
//                 transition="all 0.2s"
//               />
//             </HStack>
//           </VStack>

//           {/* Quick Links */}
//           <VStack align="start" spacing={6}>
//             <Heading
//               fontSize="lg"
//               color={useColorModeValue("gray.800", "gray.200")}
//               fontFamily="Montserrat"
//               fontWeight="600"
//             >
//               Quick Links
//             </Heading>
//             <VStack align="start" spacing={3}>
//               {navigationLinks.map((link, idx) => (
//                 <Link
//                   key={idx}
//                   href={link.href}
//                   onClick={scrollToTop}
//                   fontSize="sm"
//                   color="gray.600"
//                   _hover={{ color: "blue.500", textDecoration: "none" }}
//                   transition="all 0.2s"
//                 >
//                   {link.label}
//                 </Link>
//               ))}
//             </VStack>
//           </VStack>

//           {/* Contact Info */}
//           <VStack align="start" spacing={6}>
//             <Heading
//               fontSize="lg"
//               color={useColorModeValue("gray.800", "gray.200")}
//               fontFamily="Montserrat"
//               fontWeight="600"
//             >
//               Contact
//             </Heading>
//             <VStack align="start" spacing={4}>
//               <HStack spacing={3}>
//                 <Box color="blue.500">
//                   <FaMapMarkerAlt />
//                 </Box>
//                 <Text fontSize="sm" color="gray.600">
//                   Mircea Vulcanescu Street, No. 45
//                   <br />
//                   Sector 1, Bucharest
//                 </Text>
//               </HStack>
//               <HStack spacing={3}>
//                 <Box color="blue.500">
//                   <FaEnvelope />
//                 </Box>
//                 <Link
//                   href="mailto:office@travel-time.ro"
//                   fontSize="sm"
//                   color="gray.600"
//                   _hover={{ color: "blue.500" }}
//                 >
//                   office@travel-time.ro
//                 </Link>
//               </HStack>
//               <HStack spacing={3}>
//                 <Box color="blue.500">
//                   <FaPhone />
//                 </Box>
//                 <Link
//                   href="tel:+40371121272"
//                   fontSize="sm"
//                   color="gray.600"
//                   _hover={{ color: "blue.500" }}
//                 >
//                   +40 371 121 272
//                 </Link>
//               </HStack>
//             </VStack>
//           </VStack>

//           {/* Company Details & Certifications */}
//           <VStack align="start" spacing={6}>
//             <Heading
//               fontSize="lg"
//               color={useColorModeValue("gray.800", "gray.200")}
//               fontFamily="Montserrat"
//               fontWeight="600"
//             >
//               Company Details
//             </Heading>
//             <VStack align="start" spacing={2}>
//               <Text fontSize="sm" color="gray.600" fontWeight="500">
//                 SC TRAVEL TIME D&R SRL
//               </Text>
//               <Text fontSize="xs" color="gray.500">
//                 CIF: RO17926970
//               </Text>
//               <Text fontSize="xs" color="gray.500">
//                 Nr. Reg. Com.: J40/15226/2005
//               </Text>
//             </VStack>

//             {/* Certification Logos */}
//             <VStack spacing={4} align="start">
//               <Text fontSize="sm" fontWeight="500" color="gray.700">
//                 Certifications & Partners
//               </Text>
//               <Wrap spacing={2}>
//                 <WrapItem>
//                   <Image src="../images/iata.png" alt="IATA" h="25px" />
//                 </WrapItem>
//                 <WrapItem>
//                   <Image src="../images/anat.png" alt="ANAT" h="25px" />
//                 </WrapItem>
//                 <WrapItem>
//                   <Image
//                     src="../images/logo-travelnation.png"
//                     alt="Travel Nation"
//                     h="25px"
//                   />
//                 </WrapItem>
//               </Wrap>
//             </VStack>
//           </VStack>
//         </SimpleGrid>
//       </Container>

//       <Divider borderColor={borderColor} />

//       {/* Expandable Sections */}
//       <Container maxW="7xl" py={8}>
//         <VStack spacing={6}>
//           {/* Certifications Section */}
//           <Box w="full">
//             <Button
//               variant="ghost"
//               size="lg"
//               onClick={() => setShowCertifications(!showCertifications)}
//               rightIcon={
//                 showCertifications ? <FaChevronUp /> : <FaChevronDown />
//               }
//               w="full"
//               justifyContent="space-between"
//               bg={cardBg}
//               borderWidth="1px"
//               borderColor={borderColor}
//               _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
//             >
//               <HStack>
//                 <FaCertificate color="#3182CE" />
//                 <Text fontFamily="Montserrat" fontWeight="600">
//                   Certifications & Official Documents
//                 </Text>
//                 <Badge colorScheme="blue" variant="subtle">
//                   {certificationDocs.length}
//                 </Badge>
//               </HStack>
//             </Button>

//             <Collapse in={showCertifications}>
//               <Box
//                 mt={4}
//                 p={6}
//                 bg={cardBg}
//                 borderRadius="lg"
//                 borderWidth="1px"
//                 borderColor={borderColor}
//               >
//                 <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
//                   {certificationDocs.map((doc, idx) => (
//                     <Link
//                       key={idx}
//                       href={doc.href}
//                       isExternal
//                       _hover={{ textDecoration: "none" }}
//                     >
//                       <Box
//                         p={4}
//                         borderRadius="md"
//                         borderWidth="1px"
//                         borderColor={borderColor}
//                         transition="all 0.2s"
//                         _hover={{
//                           transform: "translateY(-2px)",
//                           boxShadow: "md",
//                           borderColor: `${doc.color}.300`,
//                         }}
//                       >
//                         <HStack spacing={3}>
//                           <Box color={`${doc.color}.500`}>
//                             <doc.icon />
//                           </Box>
//                           <VStack align="start" spacing={1}>
//                             <Text
//                               fontSize="sm"
//                               fontWeight="500"
//                               color="gray.700"
//                             >
//                               {doc.label}
//                             </Text>
//                             <HStack spacing={1}>
//                               <FaExternalLinkAlt size={10} color="#A0AEC0" />
//                               <Text fontSize="xs" color="gray.500">
//                                 View Document
//                               </Text>
//                             </HStack>
//                           </VStack>
//                         </HStack>
//                       </Box>
//                     </Link>
//                   ))}
//                 </SimpleGrid>
//               </Box>
//             </Collapse>
//           </Box>

//           {/* Legal Documents Section */}
//           <Box w="full">
//             <Button
//               variant="ghost"
//               size="lg"
//               onClick={() => setShowDocuments(!showDocuments)}
//               rightIcon={showDocuments ? <FaChevronUp /> : <FaChevronDown />}
//               w="full"
//               justifyContent="space-between"
//               bg={cardBg}
//               borderWidth="1px"
//               borderColor={borderColor}
//               _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
//             >
//               <HStack>
//                 <FaGavel color="#3182CE" />
//                 <Text fontFamily="Montserrat" fontWeight="600">
//                   Legal Documents & Policies
//                 </Text>
//                 <Badge colorScheme="green" variant="subtle">
//                   {legalDocs.length}
//                 </Badge>
//               </HStack>
//             </Button>

//             <Collapse in={showDocuments}>
//               <Box
//                 mt={4}
//                 p={6}
//                 bg={cardBg}
//                 borderRadius="lg"
//                 borderWidth="1px"
//                 borderColor={borderColor}
//               >
//                 <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
//                   {legalDocs.map((doc, idx) => (
//                     <Link
//                       key={idx}
//                       href={doc.href}
//                       isExternal
//                       _hover={{ textDecoration: "none" }}
//                     >
//                       <Box
//                         p={4}
//                         borderRadius="md"
//                         borderWidth="1px"
//                         borderColor={borderColor}
//                         transition="all 0.2s"
//                         _hover={{
//                           transform: "translateY(-2px)",
//                           boxShadow: "md",
//                           borderColor: "green.300",
//                         }}
//                       >
//                         <HStack spacing={3}>
//                           <Box color="green.500">
//                             <doc.icon />
//                           </Box>
//                           <VStack align="start" spacing={1}>
//                             <Text
//                               fontSize="sm"
//                               fontWeight="500"
//                               color="gray.700"
//                             >
//                               {doc.label}
//                             </Text>
//                             <HStack spacing={1}>
//                               <FaExternalLinkAlt size={10} color="#A0AEC0" />
//                               <Text fontSize="xs" color="gray.500">
//                                 View Document
//                               </Text>
//                             </HStack>
//                           </VStack>
//                         </HStack>
//                       </Box>
//                     </Link>
//                   ))}
//                 </SimpleGrid>

//                 {/* External Links */}
//                 <Divider my={6} />
//                 <VStack spacing={3}>
//                   <Text fontSize="sm" fontWeight="500" color="gray.700">
//                     External Resources
//                   </Text>
//                   <Wrap justify="center" spacing={4}>
//                     <WrapItem>
//                       <Link
//                         href="https://anpc.ro/"
//                         isExternal
//                         fontSize="sm"
//                         color="blue.600"
//                         _hover={{ color: "blue.400" }}
//                       >
//                         ANPC{" "}
//                         <FaExternalLinkAlt
//                           style={{ display: "inline", marginLeft: "4px" }}
//                           size={10}
//                         />
//                       </Link>
//                     </WrapItem>
//                     <WrapItem>
//                       <Link
//                         href="https://anpc.ro/ce-este-sal/"
//                         isExternal
//                         fontSize="sm"
//                         color="blue.600"
//                         _hover={{ color: "blue.400" }}
//                       >
//                         SOL{" "}
//                         <FaExternalLinkAlt
//                           style={{ display: "inline", marginLeft: "4px" }}
//                           size={10}
//                         />
//                       </Link>
//                     </WrapItem>
//                     <WrapItem>
//                       <Link
//                         href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN"
//                         isExternal
//                         fontSize="sm"
//                         color="blue.600"
//                         _hover={{ color: "blue.400" }}
//                       >
//                         EU ODR{" "}
//                         <FaExternalLinkAlt
//                           style={{ display: "inline", marginLeft: "4px" }}
//                           size={10}
//                         />
//                       </Link>
//                     </WrapItem>
//                   </Wrap>
//                 </VStack>
//               </Box>
//             </Collapse>
//           </Box>
//         </VStack>
//       </Container>

//       <Divider borderColor={borderColor} />

//       {/* Bottom Bar */}
//       <Box py={6} bg={useColorModeValue("gray.100", "gray.800")}>
//         <Container maxW="7xl">
//           <Center
//             direction={{ base: "column", md: "row" }}
//             justify="space-between"
//             align="center"
//             gap={4}
//           >
//             <Text
//               fontSize="sm"
//               color={useColorModeValue("gray.600", "gray.400")}
//               textAlign={{ base: "center", md: "left" }}
//             >
//               © {new Date().getFullYear()} Travel Time D&R. All rights reserved.
//             </Text>
//           </Center>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default ModernFooter;
